module.exports = __webpack_public_path__ + "static/media/service-landscape.73ef04dc.jpg";